import {
  IsNotEmpty,
  IsArray,
  IsOptional,
  ValidateNested,
} from "class-validator";

import { IAdapterBacklogRuleAction } from "./adapter-backlog-rule-action.interface";
import { Type } from "class-transformer";

import { QueryDto } from "../query";

export class AdapterBacklogRuleActionDto implements IAdapterBacklogRuleAction {
  // Other ERP specific attributes
  [s: string]: any;

  @IsOptional()
  @IsArray()
  entity_ids?: string[];

  @IsOptional()
  @ValidateNested()
  @Type(() => QueryDto)
  query?: QueryDto;

  @IsNotEmpty()
  rule_id: string;

  @IsOptional()
  action_id?: string;
}
